import { createReducer, on } from '@ngrx/store';
import { Event } from '../../models';
import * as actions from '../actions/related-events.action';
import { ToEntities } from '@teamfoster/sdk/array-utility';

export interface RelatedEventsState {
  entities: Event[];
  loaded: boolean;
  loading: boolean;
  error?: any;
}

export const initialState: RelatedEventsState = {
  entities: [],
  loaded: false,
  loading: false,
};

export const RelatedEventsReducer = createReducer(
  initialState,

  on(actions.LoadRelatedEvents, (state: RelatedEventsState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(actions.LoadRelatedEventsSuccess, (state: RelatedEventsState, { events }) => {
    return {
      ...state,
      entities: events,
      loading: false,
      loaded: true,
    };
  }),
  on(actions.LoadRelatedEventsFail, (state: RelatedEventsState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  })
);

export const getRelatedEventsEntities = (state: RelatedEventsState) => state.entities;
export const getRelatedEventsLoading = (state: RelatedEventsState) => state.loading;
export const getRelatedEventsLoaded = (state: RelatedEventsState) => state.loaded;
export const getRelatedEventsError = (state: RelatedEventsState) => state.error;
